"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _orderBy2 = _interopRequireDefault(require("lodash/orderBy"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _groupBy2 = _interopRequireDefault(require("lodash/groupBy"));
var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");
var _store = require("@tajawal/web-core-sdk-v2/lib/utils/store.utils");
var _sale = require("../clients/sale.client");
var _sale2 = require("../utils/sale.utils");
var _constants2 = require("../constants");
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
/**
 * Sale booking Store
 */
let SaleBookingsStore = (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param initialState
   */
  function SaleBookingsStore(initialState = {}, $env) {
    (0, _classCallCheck2.default)(this, SaleBookingsStore);
    (0, _initializerDefineProperty2.default)(this, "data", _descriptor, this);
    (0, _initializerDefineProperty2.default)(this, "upcomingData", _descriptor2, this);
    (0, _initializerDefineProperty2.default)(this, "pastData", _descriptor3, this);
    (0, _initializerDefineProperty2.default)(this, "API_STATE", _descriptor4, this);
    /**
     * fetch sales
     * @param {Number} page
     * @param {Function} errorHandler
     */
    (0, _initializerDefineProperty2.default)(this, "fetch", _descriptor5, this);
    this.updateInitialState(initialState);
    this.$env = $env;
  }
  (0, _createClass2.default)(SaleBookingsStore, [{
    key: "isUpcomingLoading",
    get:
    /**
     * is upcoming loading
     * @return {boolean}
     */
    function () {
      return this.API_STATE[_constants2.ACTION_TYPES_SALES.FETCH_UPCOMING_SALES_LIST] === _constants.API_STATE.LOADING;
    }

    /**
     * is upcoming fetched
     * @return {boolean}
     */
  }, {
    key: "isUpcomingFetched",
    get: function () {
      return this.API_STATE[_constants2.ACTION_TYPES_SALES.FETCH_UPCOMING_SALES_LIST] === _constants.API_STATE.SUCCESS;
    }

    /**
     * has upcoming error
     * @return {boolean}
     */
  }, {
    key: "hasUpcomingError",
    get: function () {
      return this.API_STATE[_constants2.ACTION_TYPES_SALES.FETCH_UPCOMING_SALES_LIST] === _constants.API_STATE.FAILED;
    }

    /**
     * is past loading
     * @return {boolean}
     */
  }, {
    key: "isPastLoading",
    get: function () {
      return this.API_STATE[_constants2.ACTION_TYPES_SALES.FETCH_PAST_SALES_LIST] === _constants.API_STATE.LOADING;
    }

    /**
     * is upcoming fetched
     * @return {boolean}
     */
  }, {
    key: "isPastFetched",
    get: function () {
      return this.API_STATE[_constants2.ACTION_TYPES_SALES.FETCH_PAST_SALES_LIST] === _constants.API_STATE.SUCCESS;
    }

    /**
     * has upcoming error
     * @return {boolean}
     */
  }, {
    key: "hasPastError",
    get: function () {
      return this.API_STATE[_constants2.ACTION_TYPES_SALES.FETCH_PAST_SALES_LIST] === _constants.API_STATE.FAILED;
    }
  }, {
    key: "onSuccess",
    value:
    /**
     * handle success
     * @param {Object} data
     */
    function onSuccess(data, bookingType) {
      this.data = data;
      console.log(bookingType, data);
      if (bookingType === 'past') {
        this.API_STATE[_constants2.ACTION_TYPES_SALES.FETCH_PAST_SALES_LIST] = _constants.API_STATE.SUCCESS;
        this.pastData = data;
      } else {
        this.API_STATE[_constants2.ACTION_TYPES_SALES.FETCH_UPCOMING_SALES_LIST] = _constants.API_STATE.SUCCESS;
        this.upcomingData = data;
      }
      this.bookingType = '';
    }

    /**
     * handle error
     * @param {Object} error
     * @param {Function} errorHandler
     */
  }, {
    key: "onError",
    value: function onError(error, errorHandler, bookingType) {
      errorHandler(error);
      if (bookingType === 'past') {
        this.API_STATE[_constants2.ACTION_TYPES_SALES.FETCH_PAST_SALES_LIST] = _constants.API_STATE.FAILED;
      } else {
        this.API_STATE[_constants2.ACTION_TYPES_SALES.FETCH_UPCOMING_SALES_LIST] = _constants.API_STATE.FAILED;
      }
      this.bookingType = '';
    }

    /**
     * get bookings
     * @return {Array} orders
     */
  }, {
    key: "sales",
    get: function () {
      // console.log(DommyData, 'DommyData');
      // return DommyData.data;
      return this.data.data;
    }

    /**
     * get bookings
     * @return {Array} orders
     */
  }, {
    key: "upcomingSales",
    get: function () {
      return this.upcomingData.data;
    }

    /**
     * get bookings
     * @return {Array} orders
     */
  }, {
    key: "pastSales",
    get: function () {
      return this.pastData.data;
    }

    /**
     * get bookings
     * @return {Array} orders
     */
  }, {
    key: "bookings",
    get: function () {
      var _this$sales;
      return (_this$sales = this.sales) === null || _this$sales === void 0 ? void 0 : _this$sales.map(sale => {
        return (0, _sale2.groupByBookingsByOrderFactory)(sale.bookings, this.$env, sale);
      });
    }

    /**
     * get bookings
     * @return {Array} orders
     */
  }, {
    key: "upcomingbookings",
    get: function () {
      var _this$upcomingSales;
      return (_this$upcomingSales = this.upcomingSales) === null || _this$upcomingSales === void 0 ? void 0 : _this$upcomingSales.map(sale => {
        return (0, _sale2.groupByBookingsByOrderFactory)(sale.bookings, this.$env, sale);
      });
    }

    /**
     * get bookings
     * @return {Array} orders
     */
  }, {
    key: "pastbookings",
    get: function () {
      var _this$pastSales;
      return (_this$pastSales = this.pastSales) === null || _this$pastSales === void 0 ? void 0 : _this$pastSales.map(sale => {
        return (0, _sale2.groupByBookingsByOrderFactory)(sale.bookings, this.$env, sale);
      });
    }

    /**
     * total
     * @return {Array} total
     */
  }, {
    key: "totalPages",
    get: function () {
      return (0, _get2.default)(this.data, 'totalPages');
    }

    /**
     * currentPage
     * @return {Number} currentPage
     */
  }, {
    key: "currentPage",
    get: function () {
      return (0, _get2.default)(this.data, 'currentPage');
    }

    /**
     * update initial state
     * @param {Object} initialState
     */
  }, {
    key: "updateInitialState",
    value: function updateInitialState(initialState) {
      (0, _store.mapInitialStateToStoreState)(this, initialState);
    }
  }]);
  return SaleBookingsStore;
}(), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "data", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "upcomingData", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "pastData", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "API_STATE", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      [_constants2.ACTION_TYPES_SALES.FETCH_UPCOMING_SALES_LIST]: _constants.API_STATE.INITIAL,
      [_constants2.ACTION_TYPES_SALES.FETCH_PAST_SALES_LIST]: _constants.API_STATE.INITIAL
    };
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isUpcomingLoading", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isUpcomingLoading"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isUpcomingFetched", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isUpcomingFetched"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasUpcomingError", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasUpcomingError"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isPastLoading", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPastLoading"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isPastFetched", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPastFetched"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasPastError", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasPastError"), _class.prototype), _descriptor5 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "fetch", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return (0, _mobx.flow)(function* ({
      page = 1,
      size = 100,
      bookingType,
      errorHandler = () => {},
      seperateRequest
    }) {
      this.bookingType = bookingType;
      if (bookingType === 'past') {
        this.API_STATE[_constants2.ACTION_TYPES_SALES.FETCH_PAST_SALES_LIST] = _constants.API_STATE.LOADING;
      } else {
        this.API_STATE[_constants2.ACTION_TYPES_SALES.FETCH_UPCOMING_SALES_LIST] = _constants.API_STATE.LOADING;
      }
      try {
        const response = yield _sale.SaleClient.getSaleList(page, size, bookingType, seperateRequest);
        this.onSuccess(response, bookingType);
      } catch (error) {
        this.onError(error, errorHandler, bookingType);
      }
    });
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "onSuccess", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSuccess"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "onError", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onError"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "sales", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sales"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "upcomingSales", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "upcomingSales"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "pastSales", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pastSales"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "bookings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "bookings"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "upcomingbookings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "upcomingbookings"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "pastbookings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pastbookings"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "totalPages", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "totalPages"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "currentPage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentPage"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateInitialState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype)), _class);
exports.default = SaleBookingsStore;